import React, { memo, useCallback } from "react";
import useProduct from "../../../hooks/useProduct";
import ProductItem from "./ProductItem";
import Loader from "../../../components/Loader";

const ProductList = memo(() => {
  const {
    products = [],
    isLoading,
    productQuery,
    setSearch,
    search,
  } = useProduct();

  const handleSearch = useCallback((event) => {
    const { value } = event.target;
    setSearch(value);
  }, [setSearch]);

  const handleClearSearch = useCallback(() => {
    setSearch("");
  }, [setSearch]);

  return (
    <div className="col-lg-9 col-sm-12">
      <div className="input-item mb-30">
        <Input
          type="text"
          placeholder="Pesquisa"
          value={search}
          onChange={handleSearch}
          onClickX={handleClearSearch}
          aria-label="Campo de pesquisa de produtos"
        />
      </div>
      <div>
        <div className="row">
          {productQuery.total_pages === 0 ? (
            <h1 style={{ color: "red", textAlign: "center" }} role="alert">
              Nenhum produto encontrado!
            </h1>
          ) : isLoading ? (
            <Loader type="pulse" size="medium" />
          ) : (
            products.map((e) => <ProductItem key={e.product_id} {...e} />)
          )}
        </div>
      </div>
    </div>
  );
});

ProductList.displayName = "ProductList";
export default ProductList;

export const Input = ({ onClickX, ...props }) => {
  return (
    <div style={{ display: "flex", position: "relative", alignItems: "center" }}>
      <input {...props} />
      {props.value && onClickX && (
        <button
          type="button"
          onClick={onClickX}
          title="Limpar pesquisa"
          style={{
            background: "transparent",
            border: "none",
            padding: "0 8px",
            cursor: "pointer",
            position: "absolute",
            right: 40,
          }}
          aria-label="Limpar pesquisa"
        >
          <i className="fa-solid fa-times"></i>
        </button>
      )}
      <div
        style={{
          background: "transparent",
          position: "absolute",
          right: onClickX && props.value ? 60 : 40,
          border: "none",
          padding: 0,
          margin: 0,
          pointerEvents: "none",
        }}
      >
        <i className="fa-solid fa-magnifying-glass"></i>
      </div>
    </div>
  );
};
